import { updateOrAddColumnOptionState, updateOrAddColumnTemplate, updateOrAddDatapointRequest } from "../../helpers";
import { DatapointKind } from "../../types";
import { addOrUpdateDimension, addOrUpdateDimensionToDataSelectProps, addOrUpdateMeasure, addOrUpdateMeasureToDataSelectProps, resetComponentProps, switchToDataSelectPropsMode, switchToSimpleMode } from "./bar-helper";
export const addOrUpdateDatapointForHorizontalBar = (state, action, componentProps) => {
    const newColumnOption = updateOrAddColumnOptionState(state, action.payload);
    if (newColumnOption) {
        updateOrAddColumnTemplate(state, newColumnOption);
    }
    const options = state.editor.settings?.data?.columns?.options || [];
    const dataSelectPropsMode = options.filter((o) => o.id !== action.payload.id && o.datapointKind === action.payload.datapointKind).length > 0 ||
        options.filter((o) => o.datapointKind !== action.payload.datapointKind).length > 1;
    if (dataSelectPropsMode) {
        switchToDataSelectPropsMode(componentProps, state?.editor?.settings?.data?.columns?.options || []);
        if (action.payload.datapointKind === DatapointKind.Dimension) {
            addOrUpdateDimensionToDataSelectProps(state, action, componentProps);
        }
        else if (action.payload.datapointKind === DatapointKind.Measure) {
            addOrUpdateMeasureToDataSelectProps(state, action, componentProps);
        }
    }
    else {
        updateOrAddDatapointRequest(state, action.payload);
        if (action.payload.datapointKind === DatapointKind.Dimension) {
            addOrUpdateDimension(state, action, componentProps);
        }
        else if (action.payload.datapointKind === DatapointKind.Measure) {
            addOrUpdateMeasure(state, action, componentProps);
        }
    }
};
export const removeDatapointsForHorizontalBar = (state, componentProps) => {
    const options = state.editor.settings?.data?.columns?.options || [];
    const simpleMode = options.filter((o) => o.datapointKind === DatapointKind.Measure).length <= 1 &&
        options.filter((o) => o.datapointKind === DatapointKind.Dimension).length <= 1;
    if (simpleMode) {
        switchToSimpleMode(componentProps);
    }
    if (options?.length <= 1) {
        resetComponentProps(state, options, componentProps);
    }
};
